import { UserInput } from 'src/actuators/user-input/types.ts';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations.ts';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';

export const buildDesignDataContent = (props : {
    userInput: UserInput;
    translate: BelimoTranslate;
    currentRegion: RegionsEnum;
    currentLocale: LocalesEnum;
    isLinear: boolean;
}): string => prepareUserInputFormValues(props).map(([key, val, unit]) => {
    const unitStr = unit.length > 0 ? ` ${props.translate(unit)}` : '';
    return `${props.translate(`${key}`)} ${val}${unitStr}`;
}).join(', ');
